var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10.0312,
    width: 16.4754,
    height: 27.3018,
    rx: 2.68224,
    transform: "rotate(-34.1913 0 10.0312)",
    fill: "#D0B523"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.620994,
    y: 9.91269,
    width: 17.3695,
    height: 28.1958,
    rx: 3.12928,
    transform: "rotate(-34.1913 -0.620994 9.91269)",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.89408
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8418,
    y: 1.2168,
    width: 16.4754,
    height: 27.3018,
    rx: 2.68224,
    fill: "#FFD702"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3948,
    y: 0.769757,
    width: 17.3695,
    height: 28.1958,
    rx: 3.12928,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.89408
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCard);
export default __webpack_public_path__ + "static/media/yellow-card.c0ef7d809290f2f4b369adcccfefac28.svg";
export { ForwardRef as ReactComponent };